import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import { queryClient } from './lib/queryClient'
import { router } from './router'
import { useAuthStore } from './features/auth/auth.store'
import './index.css'
import { Toaster } from 'sonner';
import { NetworkIndicator } from '@shopmuchmore/api';

// Initialize theme from store
const theme = useAuthStore.getState().appSettings.theme
if (theme === 'dark') {
  document.documentElement.classList.add('dark')
} else {
  document.documentElement.classList.remove('dark')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools initialIsOpen={false} />
        <NetworkIndicator />
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            classNames: {
              toast: 'font-sans',
              title: 'font-sans',
              description: 'font-sans',
            },
          }}
          className="font-sans"
        />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
)

